export const SURVEY_KEYS = {
  CHECKLIST_TEMPLATE_USED: 'checklist-template-used-prod',
} as const;
